import { Collection } from 'core/model/Collection';
import { Model } from 'core/model/Model';

export const modelFinder = <R extends { id: string | number }, M extends Model<R>, T extends Collection<M>>(
  collection: T,
  param: string & keyof R
) => {
  const map = collection.reduce((acc, curr) => {
    if (curr.get(param)) {
      acc.set(curr.get(param), curr);
    }
    return acc;
  }, new Map<string | unknown, M>());
  return (name: string) => map.get(name);
};
